import { addDoc } from 'firebase/firestore/lite'

const createDoc = async (getCollection, data) => addDoc(getCollection(), data)

export default createDoc
